<script>
import { Doughnut } from "vue-chartjs";
import 'chartjs-plugin-labels';

export default {
  extends: Doughnut,
  props: ["chartdata", "options"],
  mounted() {
    this.drawChart();
  },
  computed: {
    chartData: function() {
      return this.chartdata;
    }
  },
  methods: {
    drawChart: function() {
      this.renderChart(this.chartdata, this.options);
    }
  },
  watch: {
    chartData: function() {
      this.drawChart();
    }
  }
};
</script>